import { ChannelGroupListResponse, ChannelGroupSchema, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchChannelGroups = async (accountId, signal) => ChannelGroupListResponse.parse(await request(`/api/v1/communication/channels/${accountId}/groups`, {
    signal,
})).groups;
export const followChannelGroup = async (accountId, input) => ChannelGroupSchema.parse(await request(`/api/v1/communication/channels/${accountId}/groups`, {
    method: 'POST',
    body: input,
}));
export const setChannelGroupParty = async (contactId, partyId) => ChannelGroupSchema.parse(await request(`/api/v1/communication/groups/${contactId}`, {
    method: 'PATCH',
    body: { partyId },
}));
export const unfollowChannelGroup = async (contactId) => ChannelGroupSchema.parse(await request(`/api/v1/communication/groups/${contactId}`, {
    method: 'DELETE',
}));
//# sourceMappingURL=communication-groups.js.map